import { VoiceModel } from "@/actions/db/get-models";
import { useRouter } from "next/navigation";
import { useTextToSpeechContext } from "@/components/pages/text-to-speech/components/providers/text-to-speech-provider";

export const useTtsVoiceCardHandler = () => {
  const router = useRouter();
  const { handleVoiceChange } = useTextToSpeechContext();

  const handleTtsVoiceModelClick = (model: VoiceModel) => {
    router.push(`/text-to-speech/${model.name}`);

    handleVoiceChange(model.name);
  };

  return { handleTtsVoiceModelClick };
};
